import { TagArray, type TagProps } from '@/shared/ui/tags'

import type { FC } from 'react'

import { useSelectionContext } from './selection/SelectionContext'

import { useSelectStateContext } from './SelectStateContext'

export const DisplayedValue: FC = () => {
  const { selectedOptions, selectedValues } = useSelectionContext()
  const { placeholder, maxTagsDisplayed, size, readonly } = useSelectStateContext()

  if (selectedValues.length === 0) {
    return <span className="select-placeholder">{placeholder}</span>
  }

  // Fall back to the raw value when its option isn't in the loaded list (stale or async),
  // so the user can still see and clear the selection.
  const optionByValue = new Map(selectedOptions.map(opt => [opt.value, opt]))
  const tags: TagProps[] = selectedValues.map(value => {
    const option = optionByValue.get(value)
    return {
      label: option?.displayLabel ?? option?.label ?? value,
      variant: readonly ? 'full' : 'soft',
    }
  })

  return <TagArray defaultProps={{ size: size }} tags={tags} maxTagsDisplayed={maxTagsDisplayed} />
}

DisplayedValue.displayName = 'DisplayedValue'
